function contactInitMap() {
  var myLatlng = new google.maps.LatLng(51.922800122595575, 4.480960796319359);

  var mapOptions = {
    zoom: 15,
    center: myLatlng,
    draggable: true,
    scrollwheel: false,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off", // Hide poi labels
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [
          {
            visibility: "off", // Hide transit labels
          },
        ],
      },
    ],
  };

  // var map = new google.maps.Map(
  //   document.getElementById("contact-map-canvas"),
  //   mapOptions
  // );

  // Check if the element with ID "contact-map-canvas" exists
  var contactMapElement = document.getElementById("contact-map-canvas");
  if (contactMapElement) {
    var map = new google.maps.Map(contactMapElement, mapOptions);
  }

  var marker = new google.maps.Marker({
    position: myLatlng,
    map: map,
    title: "Het Timmerhuis",
    icon: "themes/custom/tema/src/assets/icons/map-marker-black.svg", // Set the marker icon
  });
}

// document.addEventListener("DOMContentLoaded", contactInitMap);

document.addEventListener("DOMContentLoaded", function () {
  var contactMapCanvas = document.getElementById("contact-map-canvas");

  if (contactMapCanvas) {
    contactInitMap();
  }
});
